import styled, { css } from 'styled-components';
import colors from '../../helpers/colors';
import mediaQuery from '../../helpers/mediaQuery';
import spacing, { spacingWithBorder } from '../../helpers/spacing';
import { Grid, GridItem } from '../Grid';

export const splitInfoCardGridItemCss = css`
  border: 1px solid ${colors.cardBorder};
  border-radius: ${({ theme }) => `${theme.cardRadius}`};
  padding: ${spacingWithBorder(4, 1)} ${spacingWithBorder(3, 1)};

  display: flex;
  flex-direction: column;

  ${mediaQuery.tabletLandscape`
    flex-direction: row;
    padding: ${spacingWithBorder(4, 1)};
  `};
`;

export const SplitInfoCardGridItem = styled(GridItem)`
  ${splitInfoCardGridItemCss};
`;

export const GridWithMargins = styled(Grid)`
  && {
    margin-top: ${spacing(4)};
    margin-bottom: ${spacing(4)};

    ${mediaQuery.tabletLandscape`
      margin-top: ${spacing(6)};
      margin-bottom: ${spacing(6)};
    `}
  }
`;
